import { createContext, useContext } from 'react';

export interface ConversationTarget {
  userId: number;
  displayName?: string;
}

export interface ConversationDrawerValue {
  target: ConversationTarget | null;
  isOpen: boolean;
  openConversation(target: ConversationTarget): void;
  minimizeConversation(): void;
  restoreConversation(): void;
  closeConversation(): void;
}

export const ConversationDrawerContext =
  createContext<ConversationDrawerValue | null>(null);

export const useConversationDrawer = () => {
  const value = useContext(ConversationDrawerContext);
  if (!value) throw new Error('ConversationDrawerContext is required.');
  return value;
};
